import { LayoutInterval } from '../interfaces/LayoutInterval';

/** Expands the first interval to include the second interval */
export function expand(a: LayoutInterval, b: LayoutInterval): void {
    a.start = Math.min(a.start, b.start);
    a.end = Math.max(a.end, b.end);
}
